
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const ConfirmSignup = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const confirmUrl = searchParams.get('confirmation_url');
    
    if (!confirmUrl) {
      console.error('Nenhuma URL de confirmação encontrada nos parâmetros');
      setError('Link de confirmação inválido.');
      setVerifying(false);
      return;
    }

    console.log('Processando URL de confirmação:', confirmUrl);

    const verifyEmail = async () => {
      try {
        // Parse the URL properly to handle the redirect_to parameter correctly
        const parsedUrl = new URL(confirmUrl);
        
        // Get the redirect_to parameter from the URL
        const redirectTo = parsedUrl.searchParams.get('redirect_to');
        console.log('Parâmetro redirect_to encontrado:', redirectTo);
        
        // If there's a redirect_to parameter, make sure it's using the full URL with protocol
        if (redirectTo) {
          const currentOrigin = window.location.origin;
          console.log('Origem atual:', currentOrigin);
          
          // If redirect_to doesn't include the protocol, prepend it
          if (!redirectTo.startsWith('http')) {
            console.log('Corrigindo redirect_to para URL completa');
            // Replace the redirect_to parameter with the full URL
            parsedUrl.searchParams.set('redirect_to', `${currentOrigin}`);
            
            // Update the confirmation URL with the corrected redirect_to
            console.log('Redirecionando para URL corrigida');
            window.location.href = parsedUrl.toString();
            return;
          }
        }
        
        // If no issues with redirect_to, just navigate to the confirmation URL
        console.log('Redirecionando para URL de confirmação');
        window.location.href = confirmUrl;
      } catch (err) {
        console.error('Erro ao confirmar email:', err);
        setError('Ocorreu um erro ao confirmar seu email. Por favor, tente novamente.');
        setVerifying(false);
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <h1 className="text-2xl font-bold text-blue-dark mb-4">Confirmando seu email</h1>
        
        {verifying ? (
          <div className="flex flex-col items-center justify-center py-8">
            <Loader2 className="h-12 w-12 text-blue-main animate-spin mb-4" />
            <p className="text-gray-600">Verificando seu email, por favor aguarde...</p>
          </div>
        ) : error ? (
          <div className="py-6">
            <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-6">
              <p className="text-red-700">{error}</p>
            </div>
            <button
              onClick={() => navigate('/login')}
              className="px-4 py-2 bg-blue-main text-white rounded-md hover:bg-blue-dark transition-colors"
            >
              Voltar para o login
            </button>
          </div>
        ) : (
          <div className="py-6">
            <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-6">
              <p className="text-green-700">Seu email foi confirmado com sucesso!</p>
            </div>
            <button
              onClick={() => navigate('/login')}
              className="px-4 py-2 bg-blue-main text-white rounded-md hover:bg-blue-dark transition-colors"
            >
              Ir para o login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmSignup;
